










export default {
  name: 'GameQuickScore',
  props: {
    options: Array as () => number[],
  },
};
